import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {facebookContentComparison_template} from "../components/templates/facebookContentComparison_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

/**
 * Class hourlyAdPerformance.
 */
export class facebookContentComparison extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected template: facebookContentComparison_template;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string {

        return 'facebookContentComparison';
    }

    /**
     * @inheritDoc
     */
    buildContent(): Array<Element>{

        this.template = new facebookContentComparison_template('facebookContentComparison', this.viewModel, this)

        return [this.template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage() : void{

        // todo uncomment if we decide to keep this report
        /*this.template.buildDatePickerCalendar();

        this.getSearchPresetsListData();*/
    }

    /**
     * Get filter data.
     */
    protected getListFormData(): void{

        this.loadingIn(this.template.builtTemplate.children.namedItem("list-results"));
        this.template.activateLoading();

        this.XHRHdl = new XMLHttpRequestHandler('/api/facebook_content_comparison/references', [], this);
        this.XHRHdl.onReadyStateFunction = this.onFiltersDataReturn;
        this.XHRHdl.execute();
    }

    /**
     * Filters data response handler.
     *
     * @param req
     * @param obj
     */
    protected onFiltersDataReturn(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });
        }
    }

    /**
     * Get main data for tables.
     */
    protected getListData(): void{

        this.loadingIn(this.template.builtTemplate.children.namedItem('list-results'));
        this.template.activateLoading();

        let subViewModel = this.template.getViewModelForRequest();
        let baseApiUrl = '/api/facebook_content_comparison/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onFilterListDataReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    /**
     * Main data response handler.
     *
     * @param req
     * @param obj
     */
    protected onFilterListDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){


                let responseParsed = JSON.parse(req.request.response);

                obj.template.setData(responseParsed.data);
            });

            obj.template.deactivateLoading();
        }
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any){

        this.template.setDimensionFilterItem();
        this.template.setPageFilterItems(responseParsed.pages);
        this.template.setContentTypeFilterItems(responseParsed.groupedContentTypes);
        this.template.setPostIntentFilterItems(responseParsed.postIntents);
        this.template.setNetworkCategoryFilterItems(responseParsed.groupedNetworkCategories);



//        this.template.setPlatformsFilterItems(responseParsed.platforms);
//        this.template.fromHourFilter.setOptions(responseParsed.hours);
//        this.template.toHourFilter.setOptions(responseParsed.hours);
//        this.template.setLatestPulls(responseParsed.latestPulls);

/*
        this.template.dateFilter.setDate(date.toISOString().split('T')[0]);
        this.template.comparisonDateFilter.setDate(comparisonDate.toISOString().split('T')[0]);
        this.template.fromHourFilter.setSelectedOption(fromHour);
        this.template.toHourFilter.setSelectedOption(toHour);

 */
    }


    protected dataReorder(){

        this.sendNewDataRequest();
    }


    protected filterMultipleSelectorOnChange(){

        this.sendNewDataRequest();
    }


    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }


    protected filterDropdownOnChange(){

        this.sendNewDataRequest();
    }

    protected filterSimpleOnChange(){

        this.sendNewDataRequest();
    }


    protected filterSingleDateOnChange(){

        this.sendNewDataRequest();
    }
    
    protected filterDateOnChange(){

        this.sendNewDataRequest();
    }


    protected getAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };
        let usrReq_url: string = '/api/emakiCategorySuggestions/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompleteSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data){

                    obj.template.setPrimaryCategoryFilterItems(responseParsed.data);
                }
            });
        };
    }


    /**
     * Sends a new data request.
     */
    private sendNewDataRequest(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }

        this.getListData();
    }
}


// WEBPACK FOOTER //
// ./js/modules/facebookContentComparison.ts